import { render, staticRenderFns } from "./AudioText.vue?vue&type=template&id=5805edd0&scoped=true"
import script from "./AudioText.vue?vue&type=script&lang=js"
export * from "./AudioText.vue?vue&type=script&lang=js"
import style0 from "./AudioText.vue?vue&type=style&index=0&id=5805edd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805edd0",
  null
  
)

export default component.exports